import { IChat } from "dto/Chat/IChat";
import { createContext } from "react";

type IChatsContext = {
  chats: IChat[];
  setChats: (chats: IChat[]) => void;
};

const ChatsContext = createContext<IChatsContext>({
  chats: [],
  setChats: () => {},
});

export default ChatsContext;
